import { render } from "./GUeditor.vue?vue&type=template&id=1ba2c66c"
import script from "./GUeditor.vue?vue&type=script&lang=js"
export * from "./GUeditor.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data1/www/cms.jfinfo.com/jfinfo_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__